import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import Action from '../actions';
import {connect} from 'react-redux';

class ShowUnexposedPlayers extends Component {
    onCheck(isChecked) {
        this.props.dispatch(Action.do('showUnexposedPlayers', isChecked));
    }

    render() {
        const {filters} = this.props;

        return (
            <div className="lineup-control">
                <label>Show unexposed players:</label>
                <div className="lineup-control-holder">
                    <div className="filter-btn-group">
                        <button
                            type="button"
                            className={filters.isShowUnexposedPlayersEnabled() ? 'active' : ''}
                            onClick={(e) => ::this.onCheck(true)}
                        >
                            Yes
                        </button>
                        <button
                            type="button"
                            className={!filters.isShowUnexposedPlayersEnabled() ? 'active' : ''}
                            onClick={(e) => ::this.onCheck(false)}
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        usedPlayers: {filters},
    } = state;

    return {
        filters,
    };
}

export default connect(mapStatesToProps)(ShowUnexposedPlayers);
